import Vue from 'vue';

export const mutations = {
  UPDATE(state, { formularIdentifier, formData }) {
    const form = state.formData.has(formularIdentifier)
      ? {
          ...state.formData.get(formularIdentifier),
          ...formData,
        }
      : formData;
    const forms = new Map(state.formData);
    forms.set(formularIdentifier, form);
    Vue.set(state, 'formData', forms);
  },

  CLEAR(state, formularIdentifier) {
    const success = state.formData.delete(formularIdentifier);
    if (!success) return;
    const forms = new Map(state.formData);
    Vue.set(state, 'formData', forms);
  },
};
